import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Compact pagination footer for paginated API responses ({ total, page, page_size }). */
export const Pagination = ({ page, pageSize, total, onChange, testId = "pagination" }) => {
  const { t } = useTranslation();
  const pages = Math.max(1, Math.ceil((total || 0) / (pageSize || 1)));
  if (!total) return null;
  return (
    <div className="flex flex-col gap-2 border-t border-border px-4 py-3 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between" data-testid={testId}>
      <span data-testid={`${testId}-total`}>{t("common.total", { count: total })}</span>
      <div className="flex items-center gap-2">
        <span data-testid={`${testId}-page`}>{t("common.page", { page, pages })}</span>
        <Button variant="outline" size="icon" className="h-8 w-8 bg-card" disabled={page <= 1} onClick={() => onChange(page - 1)} aria-label={t("common.previous")} data-testid={`${testId}-prev`}><ChevronLeft className="h-4 w-4" /></Button>
        <Button variant="outline" size="icon" className="h-8 w-8 bg-card" disabled={page >= pages} onClick={() => onChange(page + 1)} aria-label={t("common.next")} data-testid={`${testId}-next`}><ChevronRight className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};
